import ImageAudio from 'app/components/tests/media/ImageAudio';
import GroupQuestion from 'app/components/tests/GroupQuestion';
import { AppStoreState } from 'app/redux/store';
import { Passage, Group } from 'types/test';
import { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';

const resizer = (e) => {
  const leftPane: any = document.querySelector(".form-test .left");
  const rightPane: any = document.querySelector(".form-test .right");
  window.addEventListener('mousemove', mousemove);
  window.addEventListener('touchmove', mousemove);
  window.addEventListener('mouseup', mouseup);
  window.addEventListener('touchend', mouseup);

  let prevX = e.x;
  if (e?.changedTouches?.length) {
    prevX = e?.changedTouches[0]?.clientX;
  }

  const leftPanel = leftPane.getBoundingClientRect();
  const rightPanel = rightPane.getBoundingClientRect();

  function mousemove(e) {
    let clientX = e.x;
    if (e?.changedTouches?.length) {
      clientX = e?.changedTouches[0]?.clientX;
    }

    let newX = prevX - clientX;
    leftPane.style.width = leftPanel.width - newX + "px";
    rightPane.style.width = rightPanel.width + newX + "px";
  }

  function mouseup() {
    window.removeEventListener('mousemove', mousemove);
    window.removeEventListener('touchmove', mousemove);
    window.removeEventListener('mouseup', mouseup);
    window.removeEventListener('touchend', mouseup);
  }
}

const IeltRead = ({ confirmIsReady, handleChange }) => {
  const { test, result, groupQuestions, currentPage } = useSelector((state: AppStoreState) => state.test);
  const { passages } = test;

  useEffect(() => {
    const gutter = document.querySelector(".form-test .gutter");
    gutter?.addEventListener('mousedown', resizer);
    gutter?.addEventListener('touchstart', resizer);

    return () => {
      gutter?.removeEventListener('mousedown', resizer);
      gutter?.removeEventListener('touchstart', resizer);
    }
  }, [])

  const groupsInPassage = useMemo(() => {
    return (groupQuestions || []).filter((group: Group) => group.part_id == currentPage);
  }, [groupQuestions, currentPage]);

  const groupsResultInPassage = useMemo(() => {
    return (result?.group_questions || []).filter((group: Group) => group.part_id == currentPage);
  }, [result?.group_questions, currentPage]);

  const questionInPassage = useMemo(() => {
    let string = '';
    groupsInPassage.forEach((group: Group, index: number) => {
      const arrQuestionNumber = group?.list_question?.map(question => Number(question.number)) || [];
      if (index == 0) string = Math.min(...arrQuestionNumber) + ' - ';
      if (index == groupsInPassage.length - 1) string += Math.max(...arrQuestionNumber)
    })
    return string;
  }, [groupsInPassage]);

  const questionInGroup = (group: Group) => {
    const arrQuestionNumber = group?.list_question?.map(question => Number(question.number)) || [];
    if (arrQuestionNumber.length === 1) {
      const questionNumber = arrQuestionNumber[0];
      const prevQuestionNumber = questionNumber - Number(group.number_question) + 1;
      const prefixQuestionNumber = prevQuestionNumber < questionNumber ? `${prevQuestionNumber} - ` : '';
      return prefixQuestionNumber + questionNumber;
    }
    return Math.min(...arrQuestionNumber) + ' - ' + Math.max(...arrQuestionNumber);
  }

  return (
    <div className='d-flex w-100'>
      <div className='wt-50 left'>
        {(passages || []).map((passage: Passage) => {
          return (
            <div
              className={`box-passage text-just ${passage.passage_number != currentPage ? 'd-none' : ''}`}
              key={passage.id}
              dangerouslySetInnerHTML={{ __html: passage.content }}
            />
          )
        })
        }
      </div>
      <div className="form-ielts-read wt-50 right position-relative d-flex">
        <div className="gutter"></div>
        <div>
          <h4 className="text-success pl-3 my-3">PASSAGE {currentPage}: QUESTIONS {questionInPassage}</h4>
          {groupsInPassage.map((group: Group, index: number) => {
            const groupResult = groupsResultInPassage?.length > 0 ? groupsResultInPassage[index] : null;
            return (
              <div key={group.id} className="border border-info my-2 ml-2">
                <h3 className="text-info p-2">Questions {questionInGroup(group)}</h3>
                <ImageAudio hide={false} data={group} />
                <GroupQuestion
                  group={group}
                  groupResult={groupResult}
                  handleChange={handleChange}
                  confirmIsReady={confirmIsReady}
                />
              </div>
            )
          })
          }
        </div>
      </div>
    </div>
  )
}

export default IeltRead;
